<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { onMount } from 'svelte';

    // Types
    import type { ComponentType } from 'svelte';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { Language } from '$lib/types/Language';
    import type { GridColumnContent } from '$lib/types/Components/GridColumn/GridColumnContent';

    export let id = '';
    export let content: GridColumnContent;
    export let childComponents: Component[] = [];
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let componentType = '';
    export let parentComponentType = '';
    export let campaignId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let index = 0;
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'de';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;

    let GridColumn: ComponentType;

    onMount(async () => {
        GridColumn = (await import('$lib/components/_DisplayComponents/GridColumn.svelte')).default;
    });
</script>

<svelte:component
    this={GridColumn}
    box={content.box}
    verticalAlign={content.verticalAlign}
    framed={content.framed}
    {id}
    {content}
    {childComponents}
    {resultMapping}
    {theme}
    {nextPage}
    {currentPage}
    {componentType}
    {parentComponentType}
    {campaignId}
    {companyId}
    {cookiesEnabled}
    {fields}
    {index}
    {firstResultPage}
    {trackingProperties}
    {language}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
